<div class="zeroPadding" *ngFor="let cardholder of profileSearchResults">
  <div class="row searchResultsRow" (click)="selectCardholder(cardholder);" >
    <div class="col-md-11 ">
      <div class="searchResultName">
        <div >{{cardholder.name}}</div>
      </div>
      <div class="searchResultDataName">
        {{cardholder.payGrade}}.{{cardholder.militaryBranch}}:
        <span class="searchResultDataVal">{{cardholder.shipName}}({{cardholder.location}})</span> |
        Card Number: <span class="searchResultDataVal" >{{ cardholder.cardNum | threeStars}}</span>		|
        SSN: <span class="searchResultDataVal" >{{ cardholder.socialSecurity | slice:5}}</span>
      </div>
    </div>
  </div>
</div>

